import { IconName } from '@/components/icons/Icons';

export interface NavigationItem {
  id: string;
  label: string;
  path: string;
  icon: IconName;
  badge?: string;
}

export const mainNavigation: NavigationItem[] = [
  { id: 'home', label: 'nav.home', path: '/home', icon: 'LayoutGrid' },
  { id: 'dashboard', label: 'nav.dashboard', path: '/dashboard', icon: 'ChartBar' },
  { id: 'inbox', label: 'nav.inbox', path: '/inbox', icon: 'Inbox', badge: '3' },
  { id: 'conversations', label: 'nav.conversations', path: '/conversations', icon: 'MessageSquare' },
  { id: 'orders', label: 'nav.orders', path: '/orders', icon: 'CreditCard' },
  { id: 'knowledge', label: 'nav.knowledge', path: '/knowledge', icon: 'BookOpen' },
  { id: 'apps', label: 'nav.apps', path: '/apps', icon: 'Wrench' },
  { id: 'integrations', label: 'nav.integrations', path: '/integrations', icon: 'LinkIcon' },
  { id: 'settings', label: 'nav.settings', path: '/settings', icon: 'SettingsIcon' },
];
